<template>
<div id="app">
   <div v-if="isLoggedIn">
      <home/>
    
   </div>
   <router-view/>
</div>
</template>
<script>
import home from './views/Home.vue';



import { mapGetters }  from 'vuex';
export default {
    components: {home},
     computed: {
          ...mapGetters(['isLoggedIn'])  
  },
    methods: {
    
    },
    created() 
    {
      //console.log('ROUTER',this.$router)
      
      //this.$store.commit('SET_COMPANY',{reset:false,companyId:1}) 

    }
  }
</script>
<style >

body {
   font-family : 'Roboto Condensed';
}
/*
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center_;
  _color: #2c3e50;
}

.text-link {
    color: inherit;
    text-decoration: inherit;
}
*/


</style>





